module.exports = __webpack_public_path__ + "static/media/portfolio_detail_2_research_img.9524624a.png";